import { MagentoClient } from 'lib/core/services/magento'
import { MagentoStoreConfig, ProductData } from 'lib/types'
import { normalizeProduct } from './normalize'
import { ProductAttributeList } from 'lib/core/data/common/productAttributeList/types'

interface FetchProductParams {
  magentoClient?: MagentoClient
  sku?: string
  productAttrList: ProductAttributeList
  storeConfig: MagentoStoreConfig | undefined
}

export const fetchProduct = async ({
  magentoClient,
  sku,
  productAttrList,
  storeConfig
}: FetchProductParams): Promise<ProductData | undefined> => {
  if (!sku) {
    return Promise.reject(new Error('Undefined sku'))
  }

  return Promise.all([
    magentoClient?.catalog.fetchProduct({ sku, base: true }),
    magentoClient?.catalog.fetchProduct({ sku, details: true }),
    magentoClient?.catalog.fetchProduct({ sku, links: true })
  ]).then((responses) => {
    const productResponse = responses[0]
    const detailsResponse = responses[1]
    const linksResponse = responses[2]
    const [product] = productResponse?.data.data.products.items ?? []
    const [productDetails] = detailsResponse?.data.data.products.items ?? []
    const [productLinks] = linksResponse?.data.data.products.items ?? []
    const entity = {
      ...product,
      ...productDetails,
      ...productLinks
    }

    return entity.id ? normalizeProduct({
      product: entity,
      productAttributeList: productAttrList,
      storeConfig
    }) : undefined
  })
}
